import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5adfbebf")

_pushScopeId("data-v-5adfbebf")
const _hoisted_1 = { class: "flex flex-col text-12px border-t border-gray-lp-400" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-20px py-6" }, " Rute Pengiriman ", -1)
const _hoisted_3 = { class: "flex flex-row items-center justify-between" }
const _hoisted_4 = { class: "flex flex-row items-center space-x-4 option-section" }
const _hoisted_5 = { class: "w-8" }
const _hoisted_6 = {
  key: 0,
  class: "ml-8 flex flex-row gap-2"
}
const _hoisted_7 = { class: "flex flex-row justify-end items-center" }
const _hoisted_8 = { class: "px-6" }
const _hoisted_9 = { class: "w-7/20" }
const _hoisted_10 = { class: "w-1/5" }
const _hoisted_11 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded font-medium" }
const _hoisted_12 = { class: "w-2/20" }
const _hoisted_13 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded font-medium capitalize" }
const _hoisted_14 = { class: "w-1/5 text-center" }
const _hoisted_15 = { class: "w-3/20 text-right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.route_option, (e, i) => {
        return (_openBlock(), _createBlock(_component_Accordion, {
          key: i,
          class: "text-12px xxl:text-14px mb-4 relative",
          customLabel: "",
          footer: _ctx.isEdit
        }, {
          "custom-label": _withId(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("span", _hoisted_5, "Opsi " + _toDisplayString(i + 1), 1),
                _createVNode("img", {
                  onMouseenter: ($event: any) => (_ctx.openTooltip(i)),
                  onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeTooltip && _ctx.closeTooltip(...args))),
                  src: require(`@/app/ui/assets/svg/document-text.svg`),
                  class: "w-5",
                  alt: "document-text"
                }, null, 40, ["onMouseenter", "src"]),
                (e.option_product_type != null)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(e.option_product_type, (type, index) => {
                        return (_openBlock(), _createBlock("img", {
                          key: index,
                          src: require(`@/app/ui/assets/svg/product-type/${type.toLowerCase()}-badge.svg`),
                          class: "w-10",
                          alt: type
                        }, null, 8, ["src", "alt"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createVNode(_component_Tooltip, {
                  message: e.group_option_name,
                  footer: "",
                  width: "auto",
                  customClass: 'h-10 justify-start items-center px-6 text-gray-lp-300 text-left shadow-md mt-2',
                  class: "top-2",
                  style: {"left":"100px"}
                }, null, 8, ["message"]), [
                  [_vShow, _ctx.isOpenTooltip && _ctx.OpenTooltipId == i]
                ])
              ]),
              _createVNode("div", _hoisted_7, [
                _withDirectives(_createVNode(_component_Toggle, {
                  class: "mt-1",
                  modelValue: e.option_status,
                  "onUpdate:modelValue": [($event: any) => (e.option_status = $event), () => _ctx.onChangeToggle(i)],
                  onClick: _cache[2] || (_cache[2] = event => event.stopPropagation()),
                  isConfirm: "",
                  style: {"transform":"scale(0.6)"}
                }, null, 8, ["modelValue", "onUpdate:modelValue"]), [
                  [_vShow, _ctx.isEdit]
                ]),
                _withDirectives(_createVNode("div", {
                  class: "text-sm font-medium",
                  style: {"margin-left":"-15px"}
                }, _toDisplayString(e.option_status ? "Aktif" : "Tidak Aktif"), 513), [
                  [_vShow, _ctx.isEdit]
                ]),
                _withDirectives(_createVNode(_component_ChipsV2, {
                  style: {"margin-left":"-15px"},
                  label: e.option_status ? 'active' : 'inactive'
                }, null, 8, ["label"]), [
                  [_vShow, !_ctx.isEdit]
                ])
              ])
            ])
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(e.option, (item, index) => {
                return (_openBlock(), _createBlock("div", {
                  key: index,
                  class: 
            `flex flex-row items-center py-3 ${index !== e.option.length - 1 &&
              'border-b'}`
          
                }, [
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.ellipsisString(item.option_name)), 1),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, _toDisplayString(_ctx.typeRoute(item.option_type)), 1)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, _toDisplayString(item.option_transport == "cargo"
                  ? "plane"
                  : item.option_transport), 1)
                  ]),
                  _createVNode("div", _hoisted_14, _toDisplayString(item.option_vendor_name), 1),
                  _createVNode("div", _hoisted_15, _toDisplayString(item.option_transport_min_sla) + "-" + _toDisplayString(item.option_transport_max_sla) + " Jam ", 1)
                ], 2))
              }), 128))
            ])
          ]),
          _: 2
        }, 1032, ["footer"]))
      }), 128))
    ]),
    (_ctx.defaultConfirm || _ctx.isConfirmToggle)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _ctx.modalData.onClose,
          onSubmit: _ctx.modalData.onSubmit,
          title: _ctx.modalData.title,
          message: _ctx.modalData.message,
          image: _ctx.modalData.icon,
          textCancel: _ctx.modalData.textCancel,
          textSuccess: _ctx.modalData.textSuccess,
          class: "px-8"
        }, null, 8, ["onClose", "onSubmit", "title", "message", "image", "textCancel", "textSuccess"]))
      : _createCommentVNode("", true)
  ], 64))
})